import React, { useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { Document, pdfjs, Page } from "react-pdf";
import { Dialog, Box, Paper, Typography, Button, Divider, IconButton, Tooltip } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import DownloadIcon from "@mui/icons-material/Download"; // ⭐ Jetzt aktiv genutzt!
import axios from "axios";

import "./Sheet.css";

/* Unterkomponenten-Importe */
import SideBar from "../Sidebar/SideBar";
import MdlSheetEdit  from "./MdlSheetEdit";
import SheetInformationCard from "./SheetInformationCard";
import SheetTagCategoryCard from "./SheetTagCategoryCard";
import SheetMuiStarRatingCard from './SheetMuiStarRatingCard';

/* Utils */
import { findSheetByPages, findComposerByPages, findSheetBySheets, findComposerByComposers, getCompImgUrl,
  displayDateByLanguage, displayDateTimeByLanguage } from "../../Utils/utils";

import { updateSheetRatingInStore , getComposerPage, getSheetPage, setSheetPage, setComposerPage } from "../../Redux/Actions/dataActions";

/* Aktiviert den globalen Worker für das fehlerfreie Rendern der PDF */
// pdfjs.GlobalWorkerOptions.workerSrc = `//://cloudflare.com{pdfjs.version}/pdf.worker.js`;
pdfjs.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker.entry");

function Sheet({
  sheetPages,
  composerPages,
  sheets,
  composers,
  sheetPage,
  getSheetPage,
  totalSheetPages,
  setSheetPage,
  getComposerPage,
  composerPage,
  totalComposerPages,
  setComposerPage,
  userData,
  editInfoText,
}) {
  const windowHeight = 840;
  const [isDesktop, setDesktop] = useState(window.innerHeight > windowHeight);
  
  // ⭐ FIX: Startet als null für den unfehlbaren Ladeschutz im JSX
  const [pdf, setpdf] = useState(null);
  
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [editModal, setEditModal] = useState(false);
//  const [copyText, setCopyText] = useState("Link kopieren");
  const [fullscreen, setFullscreen] = useState(false);
  const [uploaderName, setUploaderName] = useState("");
  const [updaterName, setUpdaterName] = useState("");
  const [currentLoadedPath, setCurrentLoadedPath] = useState(""); 

  let { safeSheetName, safeComposerName } = useParams();
  let history = useHistory();


  const updateMedia = () => {
    setDesktop(window.innerHeight > windowHeight);
  };

  const bySheetPages = findSheetByPages(safeSheetName, sheetPages);
  const bySheets = findSheetBySheets(safeSheetName, sheets);
  const sheet = bySheetPages || bySheets || {};

  const byComposerPages = findComposerByPages(safeComposerName, composerPages);
  const byComposers = findComposerByComposers(safeComposerName, composers);
  const composer = byComposerPages || byComposers || {};

	// 🌟 1. Korrigierte Cache-Nachladestruktur für die Sheets
	useEffect(() => {
	  // Wenn die Daten noch nicht im Redux-Store/Cache existieren
	  if (!bySheetPages && !bySheets) {
		// Validierung der Seitenzahl
		if (sheetPage === undefined || sheetPage < 0 || sheetPage > totalSheetPages) {
		  setSheetPage(1);
		}
		
		// 🌟 KORREKTUR: Wir entfernen () => window.location.reload() vollständig!
		// Redux aktualisiert den Zustand im Hintergrund, React rendert die Tabelle von alleine neu.
		getSheetPage({ page: sheetPage || 1, sortBy: "updated_at desc" });
	  }
	// 🌟 WICHTIG: Wir entfernen getSheetPage und setSheetPage aus den Abhängigkeiten,
	// da Funktionen bei jedem Render eine neue Speicheradresse bekommen und Schleifen begünstigen.
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [safeSheetName, bySheetPages, bySheets, sheetPage, totalSheetPages]);


	// 🌟 2. Korrigierte Cache-Nachladestruktur für die Komponisten
	useEffect(() => {
	  // Wenn die Komponisten-Daten noch nicht geladen sind
	  if (!byComposerPages && !byComposers) {
		// Validierung der Seitenzahl
		if (composerPage === undefined || composerPage < 0 || composerPage > totalComposerPages) {
		  setComposerPage(1);
		}
		
		// 🌟 KORREKTUR: Auch hier den harten Browser-Reload entfernen!
		getComposerPage({ page: composerPage || 1, sortBy: "updated_at desc" });
	  }
	// 🌟 WICHTIG: Auch hier nur die primitiven Datentypen im Dependency-Array belassen.
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [safeComposerName, byComposerPages, byComposers, composerPage, totalComposerPages]);
 
  // ⭐ ANALOG ZU DEN TAGS: Lädt den Namen des Benutzers separat anhand der ID nach
  const currentUploaderId = sheet ? sheet.uploaderId : null;

  useEffect(() => {
    if (!currentUploaderId) return;
    
    console.log(`🔍 Lade Uploader-Details über universelle Info-Route für User-ID: ${currentUploaderId}`);
    
    axios.get(`/users/info/${currentUploaderId}`)
      .then((res) => {
        if (res.data) {
          const firstName = res.data.first_name || res.data.firstName || "";
          const lastName = res.data.last_name || res.data.lastName || "";
          const username = res.data.username || res.data.userName || "";
          
          const fullName = `${firstName} ${lastName}`.trim();
          
          // Setzt den Klarnamen, falls vorhanden, andernfalls den Usernamen
          setUploaderName(fullName || username || `User #${currentUploaderId}`);
        }
      })
      .catch((err) => {
        console.error("Fehler beim modularisierten Nachladen des Uploadernamens:", err);
        setUploaderName(`User #${currentUploaderId}`); // Fallback
      });
  }, [currentUploaderId]); // ⭐ Die flache ID als einzige, saubere Abhängigkeit
  
  // ⭐ ANALOG ZU DEN TAGS: Lädt den Namen des Benutzers separat anhand der ID nach
  const currentUpdaterId = sheet ? sheet.updaterId : null;

  useEffect(() => {
    if (!currentUpdaterId) return;
    
    console.log(`🔍 Lade Updater-Details über universelle Info-Route für User-ID: ${currentUpdaterId}`);
    
    axios.get(`/users/info/${currentUpdaterId}`)
      .then((res) => {
        if (res.data) {
          const firstName = res.data.first_name || res.data.firstName || "";
          const lastName = res.data.last_name || res.data.lastName || "";
          const username = res.data.username || res.data.userName || "";
          
          const fullName = `${firstName} ${lastName}`.trim();
          
          // Setzt den Klarnamen, falls vorhanden, andernfalls den Usernamen
          setUpdaterName(fullName || username || `User #${currentUpdaterId}`);
        }
      })
      .catch((err) => {
        console.error("Fehler beim modularisierten Nachladen des Uploadernamens:", err);
        setUpdaterName(`User #${currentUpdaterId}`); // Fallback
      });
  }, [currentUpdaterId]); // ⭐ Die flache ID als einzige, saubere Abhängigkeit

  // ⭐ DER ECHTE RETTUNGS-HOOK: Holt das funktionierende Original-Objekt synchron ab
  // ⭐ DIAGNOSE-HOOK: Protokolliert jeden Schritt des PDF-Abrufs in der F12-Konsole
  useEffect(() => {
    if (!safeComposerName || !safeSheetName) {
      console.warn("📝 PDF-Abruf blockiert: URL-Parameter unvollständig", { safeComposerName, safeSheetName });
      return;
    }
    
    // ⭐ FIX: Erzeugt eine eindeutige Kennung für das aktuelle Lied
    const pathKey = `${safeComposerName}/${safeSheetName}`;

    // Wenn genau DIESES PDF bereits geladen im State liegt -> SOFORT ABBRECHEN!
    // Das verhindert, dass der Hook durch unruhige Router-Re-Renders getriggert wird,
    // während Sie im Dropdown-Menü eine Kategorie auswählen!
    if (pdf && currentLoadedPath === pathKey) {
      console.log("ℹ️ PDF-Abruf übersprungen: Lied ist bereits im Speicher geladen.");
      return;
    }
    
    console.log(`🚀 Start: Rufe PDF ab von /sheet/pdf/${safeComposerName}/${safeSheetName}`);
    setpdf(null); // Lade-Anzeige AKTIVIEREN WIR JETZT NUR NOCH BEI ECHTEM LIEDERWECHSEL!

    axios
      .get(`/sheet/pdf/${safeComposerName}/${safeSheetName}`, {
        responseType: "arraybuffer", 
      })
      .then((res) => {
        console.log("💾 Server-Antwort empfangen!", {
          status: res?.status,
          headers: res?.headers,
          hatData: !!res?.data,
          byteLength: res?.data ? res.data.byteLength : 0
        });

        if (res?.data && res.data.byteLength > 0) {
          const arr = new Uint8Array(res.data.slice(0, 5));
          const header = String.fromCharCode(...arr);
          console.log("📄 Magischer Datei-Header (Muss %PDF- sein):", header);
          
          setpdf({ data: new Uint8Array(res.data) }); 
          setCurrentLoadedPath(pathKey); // ⭐ Merken, was wir erfolgreich geladen haben
          console.log("🟢 State 'pdf' erfolgreich mit binärem Daten-Objekt befüllt.");
        } else {
          console.warn("⚠️ Server hat eine leere Datei geliefert.");
        }
      })
      .catch((err) => {
        if (axios.isCancel(err) || err.code === "ERR_CANCELED") {
          console.log("ℹ️ PDF-Abruf vom Browser abgebrochen (Normal bei schnellem Wechsel).");
          return;
        }
        console.error("🔴 KRITISCHER FEHLER beim PDF-Abruf vom Go-Backend:", err);
      });
  // ⭐ Fügen Sie currentLoadedPath und pdf als Absicherung im Array hinzu
  }, [safeSheetName, safeComposerName, pdf, currentLoadedPath]);

  useEffect(() => {
    document.title = `SheetAble - ${sheet.sheetName || "Sheet"}`;
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  }, [sheet.sheetName]);
  
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  // Ihre originale Download-Verbindung bleibt voll erhalten
  const [pdfDownloadData, setPdfDownloadData] = useState({ link: "", name: "" });

  function saveByteArray(reportName, byte) {
    if (!byte) return;
    var blob = new Blob([byte], { type: "application/pdf" });
    setPdfDownloadData({
      link: window.URL.createObjectURL(blob),
      name: reportName,
    });
  }

  // Initialisiert die Download-Daten, sobald das PDF-Objekt geladen wurde
  useEffect(() => {
    if (pdf && pdf.data && sheet.sheetName) {
      saveByteArray(sheet.sheetName, pdf.data);
    }
  }, [pdf, sheet.sheetName]);

  if (!composer.portraitUrl) {
    return <div style={{ padding: "20px", fontFamily: "Open Sans" }}>Lade Komponistendaten...</div>;
  }
  
  const imgUrl = getCompImgUrl(composer.portraitUrl);
  const userLang = userData?.language || 'de';
  
  return (
    <Fragment>
      {/* Sidebar ausblenden, wenn Vollbild aktiv ist */}
      {!fullscreen && <SideBar />}
      
      <div className={fullscreen ? "home_content fullscreen_active" : "home_content"}>
        <div className="document_container" style={fullscreen ? { display: "flex", justifyContent: "center", padding: 0 } : {}}>
          
          {/* LINKER BEREICH: PDF-Anzeige */}
          {!fullscreen ? (
            // A. STANDARD-ANSICHT
            <div className="doc_wrapper">
              <div className="doc_header">
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" width="100%">
                  <Box style={{ textAlign: "left" }}>
                    <span className="doc_sheet">{sheet.sheetName}</span>
                    <br />
                    <span className="doc_composer">{sheet.composer}</span>
                  </Box>
                  <Tooltip title="Vollbildmodus aktivieren">
                    <IconButton onClick={() => setFullscreen(true)} sx={{ color: "#4f40b3", backgroundColor: "rgba(79,64,179,0.05)", '&:hover': { backgroundColor: "rgba(79,64,179,0.12)" } }}>
                      <FullscreenIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </div>

              <div className="noselect document">
                {/* ⭐ LADESCHUTZ: Wartet sauber, bis das Objekt befüllt ist */}
                {pdf ? (
                  <Document
                    file={pdf}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<div style={{ padding: "20px" }}>Notenblatt wird geladen...</div>}
                  >
                    <Page 
                      pageNumber={pageNumber} 
                      width={isDesktop ? 540 : 430} 
                      renderTextLayer={false}       
                      renderAnnotationLayer={false}
                    />
                  </Document>
                ) : (
                  <div style={{ padding: "40px", fontStyle: "italic", color: "gray" }}>Notendatei wird vom Server geladen...</div>
                )}
              </div>

              <div className="page_controls">
                <button type="button" disabled={pageNumber === 1} onClick={() => setPageNumber(p => p - 1)}>&lt;</button>
                <span>{pageNumber} von {numPages || 1}</span>
                <button type="button" disabled={pageNumber === numPages || !numPages} onClick={() => setPageNumber(p => p + 1)}>&gt;</button>
              </div>
            </div>
          ) : (
            // B. DER INTEGRATIVE VOLLBILD-MODUS (Nutzt denselben sicheren State)
            <Box 
              sx={{ 
                position: "fixed", top: 0, left: 0, right: 0, bottom: 0, 
                backgroundColor: "#111111", zIndex: 999999, 
                display: "flex", justifyContent: "center", alignItems: "center",
                overflow: "hidden"
              }}
            >
              <IconButton 
                onClick={() => setFullscreen(false)} 
                sx={{ position: "absolute", top: 20, right: 20, color: "white", backgroundColor: "rgba(255,255,255,0.1)", '&:hover': { backgroundColor: "rgba(255,255,255,0.2)" } }}
              >
                <FullscreenExitIcon fontSize="large" />
              </IconButton>

              <IconButton 
                disabled={pageNumber === 1} 
                onClick={() => setPageNumber(p => p - 1)}
                sx={{ position: "absolute", left: 20, top: "50%", transform: "translateY(-50%)", color: "white", width: "70px", height: "70px", backgroundColor: "rgba(255,255,255,0.05)", '&:hover': { backgroundColor: "rgba(255,255,255,0.15)" }, '&.Mui-disabled': { color: "rgba(255,255,255,0.1)" } }}
              >
                <NavigateBeforeIcon sx={{ fontSize: "50px" }} />
              </IconButton>

              <Box className="noselect" sx={{ maxHeight: "100vh", padding: "10px", boxShadow: "0 0 40px rgba(0,0,0,0.8)" }}>
                {pdf && (
                  <Document
                    file={pdf}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<div style={{ color: "white" }}>Vollbild wird geladen...</div>}
                  >
                    <Page 
                      pageNumber={pageNumber} 
                      height={window.innerHeight - 40} 
                      renderTextLayer={false}       
                      renderAnnotationLayer={false}
                    />
                  </Document>
                )}
              </Box>

              <IconButton 
                disabled={pageNumber === numPages || !numPages} 
                onClick={() => setPageNumber(p => p + 1)}
                sx={{ position: "absolute", right: 20, top: "50%", transform: "translateY(-50%)", color: "white", width: "70px", height: "70px", backgroundColor: "rgba(255,255,255,0.05)", '&:hover': { backgroundColor: "rgba(255,255,255,0.15)" }, '&.Mui-disabled': { color: "rgba(255,255,255,0.1)" } }}
              >
                <NavigateNextIcon sx={{ fontSize: "50px" }} />
              </IconButton>

              <Typography variant="body1" sx={{ position: "absolute", bottom: 20, color: "white", backgroundColor: "rgba(0,0,0,0.6)", px: 2, py: 0.5, borderRadius: "20px", fontWeight: "600" }}>
                {pageNumber} / {numPages || 1}
              </Typography>
            </Box>
          )}

          {/* RECHTER BEREICH: Info-Block */}
          {!fullscreen && (
            <div className="right_side_doc" style={{ marginTop: "30px" }}>
              <div className="horizontal_flex_layout" style={{ display: "flex", gap: "20px" }}>
                <Paper 
                  elevation={3} 
                  style={{ 
                    width: "100%", 
                    maxWidth: "390px", 
                    padding: "25px", 
                    borderRadius: "15px",
                    backgroundColor: "white",
                    textAlign: "left"
                  }}
                >
                  <Typography variant="h6" style={{ fontWeight: "bold", color: "#1d1b31", marginBottom: "5px" }}>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Metadaten & Verlauf
                      <Button
                        component="a"
                        href={pdfDownloadData.link || "#"}
                        download={pdfDownloadData.name ? `${pdfDownloadData.name}.pdf` : "notenblatt.pdf"}
                        variant="contained"
                        size="small"
                        disabled={!pdfDownloadData.link}
                        startIcon={<DownloadIcon />}
                        style={{ backgroundColor: "#2e7d32", color: "white", textTransform: "none", borderRadius: "8px", textDecoration: "none" }}
                      >
                        Download
                      </Button>
	  				</div>
                  </Typography>

                  <Box display="flex" flexDirection="column" gap="4px">
                    <Box>
                      <Typography variant="caption" sx={{ color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Veröffentlichung
                      </Typography>
                      <Typography variant="body2" style={{ fontWeight: 500, color: "#1d1b31", marginTop: "2px" }}>
                        {displayDateByLanguage(sheet.releaseDate, userLang)}
                      </Typography>
                    </Box>

                    <Divider />

                    <Box>
                      <Typography variant="caption" sx={{ color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Hinzugefügt am
                      </Typography>
                      <Typography variant="body2" style={{ fontWeight: 500, color: "#1d1b31", marginTop: "2px" }}>
                        {displayDateTimeByLanguage(sheet.createdAt, userLang)}
                      </Typography>
                    </Box>

                    <Divider />

                    <Box>
                      <Typography variant="caption" sx={{ color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Letzte Änderung
                      </Typography>
                      <Typography variant="body2" style={{ fontWeight: 500, color: "#1d1b31", marginTop: "2px" }}>
                        {displayDateTimeByLanguage(sheet.updatedAt, userLang)}
                      </Typography>
                    </Box>

                    <Divider />

                    <Box>
                      <Typography variant="caption" sx={{ color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Hochgeladen von
                      </Typography>
                      <Typography variant="body2" style={{ fontWeight: 500, color: "#1d1b31", marginTop: "2px" }}>
                        {/* ⭐ FIX: Zeigt den separat aus der DB nachgeladenen Namen an */}
                        {uploaderName || (sheet.uploaderId ? `Lade Name...` : "-")}
                      </Typography>
                    </Box>
					

                    <Divider />

                    <Box>
                      <Typography variant="caption" sx={{ color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Geändert von
                      </Typography>
                      <Typography variant="body2" style={{ fontWeight: 500, color: "#1d1b31", marginTop: "2px" }}>
                        {/* ⭐ FIX: Zeigt den separat aus der DB nachgeladenen Namen an */}
                        {updaterName || (sheet.updaterId ? `Lade Name...` : "-")}
                      </Typography>
                    </Box>

                    <Divider />

                    <Box sx={{ mt: 2 }}>
                        <Typography variant="caption" sx={{ color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                          Bewertung
                        </Typography>
                        <SheetMuiStarRatingCard 
                          safeSheetName={sheet.safeSheetName} 
                          initialAvg={sheet.ratingAvg || 0} 
                          initialCount={sheet.ratingCount || 0} 
					      onRatingUpdated={(avg, count) => updateSheetRatingInStore(sheet.safeSheetName, avg, count)}
                        />
                    </Box>
					
				   </Box>
                </Paper>		
				
	               {/* Profilbild des Komponisten (wiederhergestellt über imgUrl) */}
                {imgUrl && (
				<div className="doc_box composer_info remove_shadow" onClick={() => history.push(`/composer/${composer.safe_name}`)} >
                  <div className="composer_portrait_wrapper" style={{ marginTop: "10px" }}>
                    <img src={imgUrl} alt={composer.name} style={{ width: "100%", maxWidth: "200px", borderRadius: "10px" }} />
					<div className="composer_info_text_wrapper">
						<span>{composer.name}</span>
						<span>{composer.disambiguation}</span>
					</div>
                  </div>
				  </div>
                )}
			  
                <Divider />

				<SheetInformationCard sheet={sheet} />
				<SheetTagCategoryCard sheet={sheet} />
              </div>
            </div>
          )}

        </div>
      </div>

	<Dialog 
	  // ⭐ FIX 1: Ein starrer, unveränderlicher Key! Er nagelt den Dialog im DOM fest 
	  // und verhindert, dass React das Fenster bei einer Router- oder Key-Fluktuation einfach löscht.
	  key="constant-edit-dialog-viewport" 
	  open={editModal} 
	  onClose={(event, reason) => {
		if (reason === "backdropClick" || reason === "escapeKeyDown") return; 
		if (event && event.target !== event.currentTarget) return; 
		setEditModal(false);
	  }}
	  disableEnforceFocus={true} 
	  maxWidth="xs"              
	  fullWidth
	  PaperProps={{ style: { borderRadius: "8px", overflow: "hidden" } }}
	>
	  <MdlSheetEdit  
		// ⭐ FIX 2: Wir übergeben beim temporären Auswählen im Dropdown nur eine flache 
		// Kopie des Objekts, damit die ID-Referenz den übergeordneten Router-Key nicht irritiert
		sheet={{ ...sheet }} 
		userData={userData}        
		editInfoText={editInfoText} 
		onClose={() => setEditModal(false)} 
	  />
	</Dialog>



    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  sheetPages: state.data.sheetPages,
  composerPages: state.data.composerPages,
  sheets: state.data.sheets,
  composers: state.data.composers,
  sheetPage: state.data.sheetPage,
  totalSheetPages: state.data.totalSheetPages,
  composerPage: state.data.composerPage,
  totalComposerPages: state.data.totalComposerPages,
  userData: state.user.userData,
});

const mapActionsToProps = {
  getSheetPage,
  getComposerPage,
  setSheetPage,
  setComposerPage,
  updateSheetRatingInStore,
};

const ConnectedSheet = connect(mapStateToProps, mapActionsToProps)(Sheet);
export default ConnectedSheet;
